import { RRIFilterOption } from './filter-options.interface';
import { RRIFilterSettings } from './filter-settings.interface';
import { RR_FILTER_TYPE } from '../../enum/filters/filter-type.enum';
import { RRISettings } from '../base-settings.interface';
import { RRIFilterBy } from './filter-by.interface';
import { RRIInputOption } from '../../../form-inputs/interfaces/input-option.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';
import { TemplateRef } from '@angular/core';
import { RRIDropdownOptionTemplate } from '../../../form-inputs/interfaces/dropdown-option-template.interface';

export interface RRIFilter<T, U>
  extends RRISettings<RR_FILTER_TYPE, RRIFilterSettings> {
  filterBy: RRIFilterBy<T>;
  options?: RRIFilterOption<U>[];
  optionsTemplate?: TemplateRef<RRIDropdownOptionTemplate<T>>;
  formSettings?: RRIInput<RRIInputOption<T> | RRIInputOption<T>[]>;
}
